<div class="grid-container padding-y-4">
    <div class="grid-row">
        <div class="grid-col-10">
            <legend class="usa-legend usa-legend--large">{{ title }}</legend>
        </div>
    </div>

    <div class="grid-row" *ngIf="delinquencyReportColDefs && delinquencyReportData">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <ag-grid-angular class="ag-theme-alpine" [gridOptions]="delinquencyReportGridOptions" [rowData]="delinquencyReportData | async" [columnDefs]="delinquencyReportColDefs" [components]="delinquencyReportFrameworkComponents" [tooltipShowDelay]="delinquencyReportTooltipShowDelay">
            </ag-grid-angular>
        </div>
    </div>
</div>
